import { styled } from 'goober';
import { ComponentChildren } from 'preact';

const Header = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface PanelHeaderProps {
  className?: string;
  onMouseDown: (e: MouseEvent) => void;
  isDragging: boolean;
  children: ComponentChildren;
}

export function PanelHeader({ className, onMouseDown, isDragging, children }: PanelHeaderProps) {
  return (
    <Header
      data-testid="panel-header"
      onMouseDown={onMouseDown}
      className={className}
      style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
    >
      {children}
    </Header>
  );
}
